module.exports = __webpack_public_path__ + "static/img/contact.f0f7615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/contact.png
// module id = x3OG
// module chunks = 1